import { Directive, input } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
export type ButtonSize = 'small' | 'medium' | 'large';
export type ButtonAction = '' | 'save' | 'delete';

/**
 * Applies UL Design System button classes to a native button or anchor.
 *
 * Use `comp-button` to select the visual variant; optionally set `size`,
 * `save`, or `iconOnly` to apply the corresponding UL modifier classes.
 */
@Directive({
  selector: 'button[comp-button], a[comp-button]',
  host: {
    '[class.ul-button]': 'true',
    '[class.-primary]': "variant() === 'primary'",
    '[class.-secondary]': "variant() === 'secondary'",
    '[class.-tertiary]': "variant() === 'tertiary'",
    '[class.-save]': 'action() === "save"',
    '[class.-delete]': 'action() === "delete"',
    '[class.-small]': "size() === 'small'",
    '[class.-medium]': "size() === 'medium'",
    '[class.-large]': "size() === 'large'",
    '[class.-icon-only]': 'iconOnly()',
  },
})
export class ButtonDirective {
  /** UL button variant. Defaults to `primary`. */
  variant = input<ButtonVariant, ButtonVariant | ''>('primary', {
    alias: 'comp-button',
    transform: (value) => (value === '' ? 'primary' : value),
  });

  /** Optional UL button size modifier. */
  size = input<ButtonSize, ButtonSize | ''>('small', {
    transform: (value) => (value === '' ? 'small' : value),
  });

  /** Applies the supported UL action modifier. */
  action = input<ButtonAction>('');

  /** Applies compact, circular icon-only button styling. */
  iconOnly = input(false);
}
